import { get, put } from './api';
import { API_ENDPOINTS } from './config';

// 会议纪要
export interface MeetingNote {
  id: number;
  taskId: string;
  version: number;
  content: string;
  contentFormat: string;
  createdAt: string;
}

// 逐字稿
export interface Utterance {
  id: number;
  text: string;
  displayText: string;
  startTime: number;
  endTime: number;
  speakerName: string;
  sequenceOrder: number;
}

// 段落
export interface Segment {
  id: number;
  segmentIndex: number;
  rawContent: string;
  rewrittenContent: string;
}

// 获取最新纪要
export async function getLatestNote(taskId: string): Promise<MeetingNote> {
  const response = await get<MeetingNote>(`${API_ENDPOINTS.NOTE.LATEST}/${taskId}`);
  return response.data;
}

// 获取纪要版本列表
export async function getNoteVersions(taskId: string): Promise<MeetingNote[]> {
  const response = await get<MeetingNote[]>(`${API_ENDPOINTS.NOTE.VERSIONS}/${taskId}`);
  return response.data;
}

// 保存用户编辑后的纪要
export async function saveEditedNote(taskId: string, content: string): Promise<{ version: number }> {
  const response = await put<{ version: number }>(`/task/${taskId}/note`, { content });
  return response.data;
}
